export interface ActionType{
  title: string;
  tipo: string;
}

export const UPDATE:ActionType = {
  title:"Editar Proyecto",
  tipo:"U"
}

export const CREATE: ActionType = {
  title:"Nuevo Proyecto",
  tipo:"I"
}